import { Ok } from "@megaron/result";

import { Serializer } from "../serializer";

export const nullable = <T>(serializer: Serializer<T>): Serializer<T | null> => ({
  ...serializer,
  serialize: (value) => {
    if (value === null) return value;
    return serializer.serialize(value);
  },
  deserialize: (raw) => {
    if (raw === null) return Ok(raw);
    return serializer.deserialize(raw);
  },
});
